import { Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const Variants = (theme: Theme) => {
  return {
    allocationCard: {
      aspectRatio: 3.7,

      "&.no-src img": {
        objectFit: "contain",
        maxWidth: "100%",
        margin: "auto",
      },
    },
    sessionCard: {
      aspectRatio: 1.78,

      "&.no-src img": {
        objectFit: "contain",
        maxWidth: "80%",
        margin: "auto",
      },
    },
    allocationTableHeader: {
      aspectRatio: 4.31,

      "&.no-src img": {
        objectFit: "contain",
        maxWidth: "50%",
        margin: "auto",
      },

      "@media (max-width: 600px)": {
        aspectRatio: 1.8,
      },
    },
    header: {
      aspectRatio: 2.31,

      "&.no-src img": {
        objectFit: "contain",
        maxWidth: "50%",
        margin: "auto",
      },

      "@media (max-width: 600px)": {
        aspectRatio: 1,
      },
    },
    squared: {
      aspectRatio: 1,

      "&.no-src img": {
        objectFit: "contain",
        maxWidth: "50%",
        margin: "auto",
      },
    },
  };
};

export const Overlays = (theme: Theme) => {
  return {
    allocationCard: {
      background: `
        linear-gradient(180deg,
          ${alpha(theme.colors["neutral.900"], 0)} 58%,
          ${alpha(theme.colors["neutral.900"], 1)} 100%)
      `,
    },
    sessionCard: {
      background: `
        linear-gradient(180deg,
          ${alpha(theme.colors["neutral.900"], 0)} 85%,
          ${alpha(theme.colors["neutral.900"], 1)} 100%)
      `,
    },
    header: {
      background: `
        linear-gradient(180deg,
          ${alpha(theme.colors["neutral.950"], 0)} 25.85%,
          ${alpha(theme.colors["neutral.950"], 0.72)} 65.21%,
          ${alpha(theme.colors["neutral.950"], 1)} 87.94%)
      `,
    },
    allocationTableHeader: {
      background: `
        linear-gradient(180deg,
          ${alpha(theme.colors["neutral.950"], 0)} 25.85%,
          ${alpha(theme.colors["neutral.950"], 0.72)} 65.21%,
          ${alpha(theme.colors["neutral.950"], 1)} 87.94%)
      `,
    },
    squared: {
      background: `
        linear-gradient(180deg,
          ${alpha(theme.colors["neutral.900"], 0)} 58%,
          ${alpha(theme.colors["neutral.900"], 1)} 100%)
      `,
    },
  };
};
